import clsx from "clsx";
import React, { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";

import { usePanelState } from "../../../../../stores/hooks/usePanelState";
import { Checkbox } from "../../../../../ui/Checkbox/Checkbox";
import { Collapsible } from "../../../../../ui/CollapsiblePannel/Collapsible";
import { usePLYOptions } from "./usePLYOptions";
import { useTirePLYRating } from "./useTirePLYRating";

const id = "dealer-tire-ply-rating-panel";

export const TirePlyRaitingFilters: FunctionComponent = () => {
  const [panelIsOpen, togglePanel] = usePanelState(id, false);
  const { t } = useTranslation();
  const [, { toggle }] = useTirePLYRating();
  const options = usePLYOptions();

  return (
    <Collapsible
      className=" space-y-2"
      id={id}
      label={t("searchResults.tirePlyRating")}
      onToggle={togglePanel}
      visible={panelIsOpen}
    >
      {options.map(({ checked, count, tirePlyRating }) => (
        <label
          className={clsx("flex gap-x-4", !count && "opacity-40")}
          key={tirePlyRating}
        >
          <Checkbox
            onChange={(): void => {
              toggle([tirePlyRating]);
            }}
            checked={checked}
            checkedClassName="text-selected-tab"
            disabled={count === 0}
            name="tirePlyRating"
          />
          <span className="flex-1">{tirePlyRating}</span>
        </label>
      ))}
    </Collapsible>
  );
};
